import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import AppBar from "./components/AppBar/AppBar";
import CartDrawer from "./components/Cart/CartDrawer";
import MedioMayoristaCartDrawer from "./components/Cart/MedioMayoristaCartDrawer";
import { CartProvider } from "./context/CartContext";
import { MedioMayoristaCartProvider } from "./context/MedioMayoristaCartContext";
import Inicio from "./views/Inicio";
import Mayorista from "./views/Mayorista";
import Ecommerce from "./views/Ecommerce";
import Footer from "./components/Footer/Footer";
import Formulario from "./sections/Formulario/Formulario";
import Nosotros from "./views/Nosotros";
import FAQ from "./views/FAQ";
import Contact from "./views/Contacto";
import ReviewToast from "./components/ReviewToast/ReviewToast";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppFloatingButton from "./components/WhatsAppFloatingButton";
import TerminosYCondiciones from "./views/TerminosYCondiciones";
import AvisoDePrivacidad from "./views/AvisoDePrivacidad";
import PoliticasDeCompra from "./views/PoliticasDeCompra";
import Facturacion from "./views/Facturacion";
import EcommerceCategory from "./views/EcommerceCategory";
import EcommerceCheckout from "./views/EcommerceCheckout";
import MedioMayoristaCheckout from "./views/MedioMayoristaCheckout";
import MedioMayoristaFiberDetail from "./views/MedioMayoristaFiberDetail";
import MedioMayoristaResinDetail from "./views/MedioMayoristaResinDetail";
import MedioMayoristaFlakesDetail from "./views/MedioMayoristaFlakesDetail";
import MedioMayoristaKitFiberResinDetail from "./views/MedioMayoristaKitFiberResinDetail";

const ecommerceSlugs = [
  "kit-omova",
  "kit-fibra-resina",
  "kit-fibra-resina-forrar",
  "kit-fibra-resina-forrar-flakes",
  "resina-epoxica",
  "fibra-carbono",
  "flakes",
];

function App() {
  return (
    <CartProvider>
      <MedioMayoristaCartProvider>
        <Router>
          <ScrollToTop />
          <div className="App">
            <AppBar />
            <Routes>
              <Route path="/" element={<Inicio />} />
              <Route path="/mayorista" element={<Mayorista />} />
              <Route path="/ecommerce" element={<Ecommerce />} />
              <Route path="/ecommerce/checkout" element={<EcommerceCheckout />} />
              <Route path="/medio-mayorista/checkout" element={<MedioMayoristaCheckout />} />
              {ecommerceSlugs.map((slug) => (
                <Route
                  key={slug}
                  path={`/ecommerce/${slug}`}
                  element={<EcommerceCategory slug={slug} />}
                />
              ))}
              <Route path="/ecommerce/:slug" element={<EcommerceCategory />} />
              <Route path="/productos" element={<Inicio />} />
              <Route path="/productos/:opcion" element={<Inicio />} />
              <Route
                path="/productos/medio-mayorista/fibra/:id"
                element={<MedioMayoristaFiberDetail />}
              />
              <Route
                path="/productos/medio-mayorista/resina/:id"
                element={<MedioMayoristaResinDetail />}
              />
              <Route
                path="/productos/medio-mayorista/flakes/:id"
                element={<MedioMayoristaFlakesDetail />}
              />
              <Route
                path="/productos/medio-mayorista/kit-fibra-resina"
                element={<MedioMayoristaKitFiberResinDetail />}
              />
              <Route path="/form" element={<Formulario />} />
              <Route path="/nosotros" element={<Nosotros />} />
              <Route path="/preguntas-frecuentes" element={<FAQ />} />
              <Route path="/contacto" element={<Contact />} />
              <Route path="/terminosYCondiciones" element={<TerminosYCondiciones />} />
              <Route path="/avisoDePrivacidad" element={<AvisoDePrivacidad />} />
              <Route path="/politicasDeCompra" element={<PoliticasDeCompra />} />
              <Route path="/facturacion" element={<Facturacion />} />
            </Routes>
            <Footer />
            <ReviewToast />
            <WhatsAppFloatingButton />
          </div>
          <CartDrawer />
          <MedioMayoristaCartDrawer />
        </Router>
      </MedioMayoristaCartProvider>
    </CartProvider>
  );
}

export default App;
